<template>
    <div class="scc-double-text-box-with-image">
        <div class="scc-double-text-box-with-image__text-boxes">
            <div class="scc-double-text-box-with-image__text-box-one">
                <div class="scc-double-text-box-with-image__text-box-one-container">
                    <h3 v-if="box1.title" class="scc-double-text-box-with-image__title">
                        {{ box1.title }}
                    </h3>
                    <p v-if="box1.text" class="scc-double-text-box-with-image__text">
                        {{ box1.text }}
                    </p>
                </div>
            </div>
            <div class="scc-double-text-box-with-image__text-box-two">
                <div class="scc-double-text-box-with-image__text-box-two-container">
                    <h3 v-if="box2.title" class="scc-double-text-box-with-image__title">
                        {{ box2.title }}
                    </h3>
                    <p v-if="box2.text" class="scc-double-text-box-with-image__text">{{ box2.text }}</p>
                </div>
            </div>
        </div>
        <div class="scc-double-text-box-with-image__image-box" :style="componentStyle">
            <div class="scc-double-text-box-with-image__image-text-container">
                <p class="scc-double-text-box-with-image__image-text">{{ box3.text }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import './double-text-box-with-image.scss';
export default {
    name: 'DoubleTextBoxWithImage',
    props: {
        box1: {
            title: {
                type: String,
                default() {
                    return 'Title';
                },
            },
            text: {
                type: String,
                default() {
                    return 'Text';
                },
            },
        },
        box2: {
            title: {
                type: String,
                default() {
                    return 'Title';
                },
            },
            text: {
                type: String,
                default() {
                    return 'Text';
                },
            },
        },
        box3: {
            image: {
                type: String,
                default() {
                    return null;
                },
            },
            text: {
                type: String,
                default() {
                    return 'Text';
                },
            },
        },
    },
    computed: {
        componentStyle() {
            return `background-image: url(${this.box3.image})`;
        },
    },
};
</script>
